import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import LoginDeriv from "./pages/LoginDeriv";
import ProfileSetup from "./pages/ProfileSetup";
import PendingApproval from "./pages/PendingApproval";
import Dashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";

// Deriv redirects to "/" with OAuth params — forward them to "/login"
function OAuthCallbackRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isOAuthCallback =
      params.has("code") ||
      params.has("token1") ||
      params.has("acct1") ||
      params.has("error");

    if (location.pathname === "/" && isOAuthCallback) {
      navigate(`/login${location.search}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <OAuthCallbackRedirect />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginDeriv />} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        <Route path="/pending" element={<PendingApproval />} />
        <Route path="/user" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
